import { useQuery } from 'react-query';

import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Recharges } from '@/types';

export const getInvoices = (): Promise<Recharges[]> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'invoices';

  return axios
    .get(endPoint)
    .then((response: any) => {
      return response._embedded?.invoices;
    })
    .catch((error) => {
      throw Error(`Critical error fetching data in ${endPoint}: ${error}`);
    });
};

type QueryFnType = typeof getInvoices;

type UseInvoicesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useInvoices = ({ config }: UseInvoicesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getInvoices(),
    ...config,
  });
};
